import { GeneralTermsAndConditions } from '@app/pcs/administration/acceptance-gtc/models/general-terms-and-conditions';
import { Action } from '@ngrx/store';

export enum AcceptanceGtcActionTypes {
  FetchGtc = '[AcceptanceGtc] Fetch GTC',
  FetchGtcSuccess = '[AcceptanceGtc] Fetch GTC Success',
  FetchGtcFail = '[AcceptanceGtc] Fetch GTC Fail',
  ChangeGtcAcceptance = '[AcceptanceGtc] Change GTC Acceptance',
  ChangeGtcAcceptanceSuccess = '[AcceptanceGtc] Change GTC Acceptance Success',
  ChangeGtcAcceptanceFail = '[AcceptanceGtc] Change GTC Acceptance Fail',
  InitTtpId = '[AcceptanceGtc] Init Ttp Id',
  SelectTtpId = '[AcceptanceGtc] Select Ttp Id',
  ResetState = '[AcceptanceGtc] Reset Acceptance GTC State'
}

export class FetchGtc implements Action {
  readonly type = AcceptanceGtcActionTypes.FetchGtc;

  constructor(public payload: number) {
  }
}

export class FetchGtcSuccess implements Action {
  readonly type = AcceptanceGtcActionTypes.FetchGtcSuccess;

  constructor(public payload: GeneralTermsAndConditions[]) {
  }
}

export class FetchGtcFail implements Action {
  readonly type = AcceptanceGtcActionTypes.FetchGtcFail;

  constructor(public payload: Error) {
  }
}

export class ChangeGtcAcceptance implements Action {
  readonly type = AcceptanceGtcActionTypes.ChangeGtcAcceptance;

  constructor(public payload: GeneralTermsAndConditions) {
  }
}

export class ChangeGtcAcceptanceSuccess implements Action {
  readonly type = AcceptanceGtcActionTypes.ChangeGtcAcceptanceSuccess;

  constructor(public payload: number) {
  }
}

export class ChangeGtcAcceptanceFail implements Action {
  readonly type = AcceptanceGtcActionTypes.ChangeGtcAcceptanceFail;

  constructor(public payload: Error) {
  }
}

export class SelectTtpId implements Action {
  readonly type = AcceptanceGtcActionTypes.SelectTtpId;

  constructor(public payload: number) {
  }
}

export class InitTtpId implements Action {
  readonly type = AcceptanceGtcActionTypes.InitTtpId;
}

export class ResetState implements Action {
  readonly type = AcceptanceGtcActionTypes.ResetState;
}

export type AcceptanceGtcActions =
  | FetchGtc
  | FetchGtcSuccess
  | FetchGtcFail
  | ChangeGtcAcceptance
  | ChangeGtcAcceptanceSuccess
  | ChangeGtcAcceptanceFail
  | SelectTtpId
  | InitTtpId
  | ResetState;
